import {Dispatch, SetStateAction, useEffect} from "react"
import { useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router"
import {validateKey} from "./api"
import {useWithSentryReport} from "../error/sentry-feedback"
import * as Sentry from "@sentry/react"


type CheckoutSuccessProps = {
    setCheckoutSuccess: Dispatch<SetStateAction<boolean>>
    setPricingModalOpen: Dispatch<SetStateAction<boolean>>
}

export function CheckoutSuccess({ setCheckoutSuccess, setPricingModalOpen }: CheckoutSuccessProps) {
    const [searchParams] = useSearchParams()
    const withCrashReport = useWithSentryReport()
    const navigate = useNavigate()

    /**
     * 2. With the 'session_id' retrieve the license key.
     */
    const validateSession = withCrashReport(async (sessionId, from) => {
        const response = await validateKey(undefined, sessionId)
        if (response.creatorKey) {
            const keyDetails = JSON.parse(response.creatorKey)
            localStorage.setItem("sessionId", keyDetails.sessionId)  // place in session
            setCheckoutSuccess(true)
            setPricingModalOpen(true)
            navigate(from)
        } else {
            console.error("Invalid creatorKey on /success for:", sessionId)
            throw new Error(`Invalid creatorKey on /success for: ${sessionId}` )
        }
    }, { id: "payment.success.unverified" }, () => navigate("/"))

    /**
     * 1. Retrieve the 'session_id' from the webhook callback.
     */
    useEffect(() => {
        const sessionId = searchParams.get("session_id")
        const from = searchParams.get("from") ?? "/"
        if (!sessionId) {
            console.warn("Missing 'session_id' on /success")
            Sentry.captureMessage("Missing 'session_id' on /success", { level: "error", extra: { sessionId: sessionId } })
            navigate(from)  // Fallback navigate
        } else
            (async () => { await validateSession(sessionId, from) })()
    }, [searchParams, validateSession, navigate])

    return null  // Nothing to render
}
